export const applyMonthDayExpansion = ({ container, expandedMonthDays, setExpandedMonthDays }) => {
  const collapseLimit = 4;
  const dayCells = container.querySelectorAll('.fc-daygrid-day[data-date]');

  dayCells.forEach((dayCell) => {
    const dateKey = dayCell.getAttribute('data-date');
    const eventsWrap = dayCell.querySelector('.fc-daygrid-day-events');
    if (!dateKey || !eventsWrap) return;

    const eventHarnesses = Array.from(eventsWrap.querySelectorAll(':scope > .fc-daygrid-event-harness'));
    const isExpanded = Boolean(expandedMonthDays[dateKey]);

    eventHarnesses.forEach((harness, index) => {
      harness.style.display = !isExpanded && index >= collapseLimit ? 'none' : '';
    });

    const totalEvents = eventHarnesses.length;
    const hiddenCount = Math.max(totalEvents - collapseLimit, 0);
    const shouldRenderToggle = hiddenCount > 0 || (isExpanded && totalEvents > collapseLimit);
    let toggleButton = eventsWrap.querySelector('.fc-day-expand-toggle');

    if (!shouldRenderToggle) {
      toggleButton?.remove();
      return;
    }

    if (!toggleButton) {
      toggleButton = document.createElement('button');
      toggleButton.type = 'button';
      toggleButton.className = 'fc-day-expand-toggle';
      toggleButton.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        setExpandedMonthDays((prev) => ({
          ...prev,
          [dateKey]: !prev[dateKey],
        }));
      });
      eventsWrap.appendChild(toggleButton);
    }

    if (isExpanded) {
      toggleButton.textContent = 'View less';
      toggleButton.setAttribute('data-expanded', 'true');
    } else {
      toggleButton.textContent = `${hiddenCount} more`;
      toggleButton.setAttribute('data-expanded', 'false');
    }
  });
};
